// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nS_Py","clinicsSelect":"styles_clinicsSelect__3ilHS"};